import { CachePolicies, useFetch } from 'use-http';
import { routes } from '@/webapi/routes';
import { FacebookAuthToken } from '@/features/integrations/facebook/facebook_redirect';
import { AdAccountList } from '@/features/integrations/facebook/models';

export function onOpenFBOAuthPopup(
  encrypt: (alias: string) => Promise<{ value: string }>,
  alias: string,
) {
  return async () => {
    const { value } = await encrypt(alias);

    const redirectURI = encodeURIComponent(`${origin}/public/fb/auth/cb/`);
    const state = encodeURIComponent(
      btoa(
        JSON.stringify({
          state: value,
          redirectURI: decodeURIComponent(redirectURI),
        }),
      ),
    );

    window.open(
      `https://www.facebook.com/v21.0/dialog/oauth?config_id=1161710951192414&state=${state}&display=popup&client_id=1175514286441606&redirect_uri=${redirectURI}&auth_type=rerequest&response_type=code&override_default_response_type=true`,
      `fboauth`,
      `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
    width=560,height=733,left=500,top=100`,
    );
  };
}

export function useStoreSettingsApi() {
  const { post, get, loading } = useFetch(``, (globalOptions) => ({
    ...globalOptions,
    ...{
      credentials: `include`,
      cachePolicy: CachePolicies.NO_CACHE,
      loading: true,
    },
  }));

  async function persist(token: FacebookAuthToken) {
    return post(routes.persistFbToken, token);
  }

  async function encrypt(alias: string): Promise<{ value: string }> {
    return post(routes.encryptAlias, { value: alias });
  }

  async function listAdAccounts(): Promise<AdAccountList> {
    return get(routes.listFbAdAccounts);
  }

  return {
    persist,
    encrypt,
    listAdAccounts,
    loading,
  };
}
